// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rates-page[data-v-4dc59b4c]{padding-right:15px}.rates-list-grid[data-v-4dc59b4c]{height:250px !important}", ""]);
// Exports
module.exports = exports;
